export default {
  // 群详情
  teamDetailUrl: '/team_home/detail/',
  teamNoticeDetailUrl: '/notice/team/detail/',
  newsTopUrl: '/news/top/',
  monthDonateLogListUrl: "/month_donate_log/list/",

  // 活动模块
  activityDetailUrl: '/activity/',
  activityLiveUrl: '/activity/live/',
  activityAlbumUrl: '/activity/album/',
  activityVoucherUrl: '/activity/cert/',

  //协议
  agreementUrl: '/app_agreement/detail/',

  uploadUrl: '/file/upload',

  //族谱
  pedigreeList: '/pedigreePeople/list',
  pedigreeDetail: '/pedigreePeople/detail/',
  pedigreeAdd: '/pedigreePeople/add',
  pedigreeDelete: '/pedigreePeople/delete/',
  pedigreeWifeList: '/pedigreePeople/wife/list/',
  pedigreeChildList: '/pedigreePeople/child/list/',
  pedigreeTree: '/pedigreePeople/self/tree/',

  //获取最新版本
  appVersionLastUrl: '/app_version/last/',
}
